import { useTheme } from '@mui/material';

export default function BackButtonIcon() {
  const theme = useTheme();
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='32' height='32' viewBox='0 0 32 32' fill='none'>
      <circle cx='16' cy='16' r='16' fill={theme.palette.primary.light} />
      <mask
        id='mask0_2725_4601'
        style={{ maskType: 'alpha' }}
        maskUnits='userSpaceOnUse'
        x='4'
        y='4'
        width='24'
        height='24'
      >
        <rect x='4' y='3.99994' width='24' height='24' fill={theme.palette.primary.main} />
      </mask>
      <g mask='url(#mask0_2725_4601)'>
        <path
          d='M23.1313 23.0967V19.4838C23.1313 18.5574 22.814 17.7667 22.1793 17.1117C21.5448 16.4566 20.7788 16.129 19.8813 16.129H10.5043L14.3543 20.1032L13.2851 21.1909L7.63135 15.3548L13.2851 9.51868L14.3543 10.6064L10.5043 14.5806H19.8813C21.1942 14.5806 22.314 15.0591 23.2408 16.016C24.1678 16.9727 24.6313 18.1287 24.6313 19.4838V23.0967H23.1313Z'
          fill={theme.palette.primary.main}
        />
      </g>
    </svg>
  );
}
